import gql from 'graphql-tag';

export const QUERY_PROPERTY_DETAILS = gql`
  query QUERY_PROPERTY_DETAILS($slug: String!) {
    property(slug: $slug) {
      id
      name
      slug
      allAmenities {
        id
        name
        iconCode
        order
      }
      propertyImages {
        id
        href
        priorityOrder
        title
        description
      }
      topAmenities {
        id
        name
        iconCode
        description
        order
      }
      cardImage {
        id
        href
      }
      address {
        address
        city
        region
        postalCode
        country
      }
      similar {
        id
        name
        slug
        topAmenities {
          id
          iconCode
          order
        }
        cardImage {
          id
          href
        }
        address {
          city
          region
        }
        shortDescription
      }
      description
      shortDescription
      affiliations {
        id
        name
        href
      }
      geo {
        lat
        lng
      }
      timeZone
      callForPricing
    }
  }
`;
